import breakpoints from './rbata.breakpoints';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import mediaLazyLoad from './rbata.mediaLazyLoad';

/*
 * This is implemented only for main banner. SEE: RBATA-1644
 */

const responsiveMedia = {
    responsiveMedia:     'responsive',
    responsiveMediaPool: [],

    getResponsiveVideos() {
        this.responsiveMediaPool =
                document.querySelectorAll(
                        `video[${this.responsiveMedia}], img[${this.responsiveMedia}]`
                );
    },

    updateSrc(breakpoint) {
        this.responsiveMediaPool.forEach(item => {

            // Exchange sources, I have to use tablet
            if (breakpoint === breakpoints.device.DESKTOP || breakpoints.device.TABLET) {
                item.dataset.src = item.dataset.srcDesktop;
            }

            if (breakpoint === breakpoints.device.MOBILE) {
                item.dataset.src = item.dataset.srcMobile;
            }

            // Add LL attributes
            item.setAttribute('animated', '');
            item.setAttribute('lazy', '');

            // Load img via LL
            mediaLazyLoad.refreshLazyLoad();
        });
    },

    bindWatcher() {
        // attach events
        Breakpoints.on('change', function () {
            responsiveMedia.updateSrc(this.current.name);
        });
    },

    init() {
        this.getResponsiveVideos();
        this.updateSrc(Breakpoints.current().name);
        this.bindWatcher();
    }
}

$(() => {
    responsiveMedia.init();
});

export default responsiveMedia;